import { DocumentReference } from '@marmon/shared/types/common';
import { Group } from '../interfaces';

export class GroupItem {
	name!: string;
	id!: string;
	ref!: DocumentReference<Group>;

	constructor(group: Group, ref: DocumentReference<Group>) {
		this.name = group.name;
		this.id = group.id;
		this.ref = ref;
	}

	toString(): string {
		return this.name;
	}

	valueOf(): DocumentReference<Group> {
		return this.ref;
	}
}
